const Functions = {
  changeQuantity(line, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ quantity: quantity, line: line }),
    })
      .then((response) => response.json())
      .then((data) => {
        window.dispatchEvent(new CustomEvent("update-cart", { detail: data }));
      })
      .catch((errror) => console.error("Error:", error));
  },
addToCart(form) {
  let formData = new FormData(form);
  let clickedButton = event.target.closest("button");

  fetch("/cart/add.js", {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .then((response) => {
      if (clickedButton && clickedButton.classList.contains("upsale-button")) {
        window.dispatchEvent(new CustomEvent("update-cart"));
      } else {
        window.dispatchEvent(new CustomEvent("update-cart"));
        window.dispatchEvent(new CustomEvent("toggle-cart"));
        document.body.classList.add("overflow-hidden");
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
},

  removeRechargeBundle(urlWithQuery) {
    return fetch(urlWithQuery, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: "" 
    })
      .then(() => fetch("/cart.js"))
      .then((r) => r.json())
      .then((data) => {
        window.dispatchEvent(new CustomEvent("update-cart", { detail: data }));
      })
      .catch((error) => {
        console.error("Recharge bundle remove failed:", error);
      })
      .finally(() => {
        window.dispatchEvent(new CustomEvent("update-cart-finished"));
      });
  }

};

window.Functions = Functions;

document.addEventListener("DOMContentLoaded", function () {
  const toggleButton = document.querySelector(".tag-dropdown-toggle");
  const dropdownList = document.querySelector(".tag-dropdown-list");
  const searchForm = document.querySelector(".search-page-form");

  if (toggleButton && dropdownList) {
    function closeDropdown() {
      dropdownList.classList.remove("active");
      toggleButton.classList.remove("open");
    }

    toggleButton.addEventListener("click", function (e) {
      e.stopPropagation();
      dropdownList.classList.toggle("active");
      toggleButton.classList.toggle("open");
    });

    document.addEventListener("click", function (e) {
      if (
        !toggleButton.contains(e.target) &&
        !dropdownList.contains(e.target)
      ) {
        closeDropdown();
      }
    });
  }

  if (searchForm) {
    document.addEventListener("click", function (e) {
      if (searchForm.contains(e.target)) {
        searchForm.classList.add("active");
      } else {
        searchForm.classList.remove("active");
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  let upsaleSwiper = null;

  const initUpsaleSwiper = () => {
    if (upsaleSwiper && typeof upsaleSwiper.destroy === "function") {
      upsaleSwiper.destroy(true, true);
    }

    const container = document.querySelector(".cart-drawer-upsale__grid-swiper");
    if (!container || container.querySelectorAll(".swiper-slide").length === 0) return;

    upsaleSwiper = new Swiper(".cart-drawer-upsale__grid-swiper", {
      slidesPerView: 1,
      speed: 600,
      navigation: {
        nextEl: ".cart-drawer__next",
        prevEl: ".cart-drawer__prev",
      },
      pagination: {
        el: ".pagination-cart-drawer",
        type: "bullets",
        clickable: true,
      },
    });
  };

  initUpsaleSwiper();

  document.addEventListener("shopify:section:load", () => {
    initUpsaleSwiper();
  });

  document.addEventListener("cart:updated", () => {
    setTimeout(() => {
      initUpsaleSwiper();
    }, 50);
  });

  window.addEventListener("cart-count-updated", () => {
    setTimeout(() => {
      initUpsaleSwiper();
    }, 50);
  });
});


